export function getFirstCuisine(cuisineType) {
    if (Array.isArray(cuisineType)) {
        if (cuisineType.length > 0) {
            return cuisineType[0];
        } else {
            return null; // Return null if the array is empty
        }
    } else if (typeof cuisineType === 'string') {
        return cuisineType;
    } else {
        return null; // Return null if the input is not a string or array
    }
}